import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8"
        >
          <motion.h1
            className="text-4xl font-serif font-bold text-gray-900 dark:text-white mb-8"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            Contact Us
          </motion.h1>

          <motion.div
            className="prose prose-lg dark:prose-invert max-w-none"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              <em>Last updated: {new Date().toLocaleDateString()}</em>
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-serif font-semibold text-gray-900 dark:text-white mb-4">
                Get in Touch
              </h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                We're here to help! Reach out to us for any questions, support, or feedback about The Super Tip.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-100 dark:bg-gray-700 p-6 rounded-lg">
                  <div className="flex items-center space-x-3 mb-4">
                    <Mail className="h-6 w-6 text-gold" />
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Email</h3>
                  </div>
                  <p className="text-gray-700 dark:text-gray-300 mb-2">
                    <strong>Email:</strong> <a href="mailto:thesupertip@gmail.com" className="text-blue-600 dark:text-blue-400 hover:underline">thesupertip@gmail.com</a>
                  </p>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    We typically respond within 24 hours.
                  </p>
                </div>

                <div className="bg-gray-100 dark:bg-gray-700 p-6 rounded-lg">
                  <div className="flex items-center space-x-3 mb-4">
                    <Clock className="h-6 w-6 text-gold" />
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Office Hours</h3>
                  </div>
                  <p className="text-gray-700 dark:text-gray-300 mb-2">
                    <strong>Mon-Fri:</strong> 9:00 AM - 6:00 PM
                  </p>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    Weekend support available for urgent matters.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-serif font-semibold text-gray-900 dark:text-white mb-4">
                Why Contact Us?
              </h2>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
                <li>Questions about our sports tips and predictions</li>
                <li>Support for account and subscription issues</li>
                <li>Feedback on our services</li>
                <li>Partnership or business inquiries</li>
                <li>Technical support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-gray-900 dark:text-white mb-4">
                Additional Information
              </h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                For privacy-related inquiries, please visit our <a href="/privacy-policy" className="text-blue-600 dark:text-blue-400 hover:underline">Privacy Policy</a>.
                For terms of service, check our <a href="/terms-of-service" className="text-blue-600 dark:text-blue-400 hover:underline">Terms of Service</a>.
              </p>
            </section>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
